export interface ParsedTag {
    category: string;
    name: string;
}

const PRIORITY_CATEGORIES = ['Company', 'Country', 'Jurisdiction', 'Topic'];

/**
 * Parse tags_json from the API which now includes category info.
 * Format: "Category||TagName,Category||TagName,..."
 * Falls back to treating the whole string as a tag name with 'Other' category.
 */
export function parseTags(tagsJson: string | null): ParsedTag[] {
    if (!tagsJson) return [];
    return tagsJson.split(',').map((entry) => {
        const trimmed = entry.trim();
        const separatorIndex = trimmed.indexOf('||');
        if (separatorIndex > -1) {
            return {
                category: trimmed.substring(0, separatorIndex),
                name: trimmed.substring(separatorIndex + 2),
            };
        }
        return { category: 'Other', name: trimmed };
    });
}

/**
 * Sort tags so that Company, Country/Jurisdiction, and Topic come first.
 * Other categories follow in their original order.
 */
export function prioritizeTags(tags: ParsedTag[]): ParsedTag[] {
    const priority: ParsedTag[] = [];
    const rest: ParsedTag[] = [];
    for (const tag of tags) {
        if (PRIORITY_CATEGORIES.some((c) => c.toLowerCase() === tag.category.toLowerCase())) {
            priority.push(tag);
        } else {
            rest.push(tag);
        }
    }
    return [...priority, ...rest];
}
